define('views/subscriptions/Podio.Views.SubscriptionsSettings',['require','translate','underscore','lib/backbone/Backbone.PodioView','jst!subscriptions/_settings_modal'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  var jstTemplate = require('jst!subscriptions/_settings_modal');

  return ViewPodioBase.extend({

    initialize: function( options ) {
      _.bindAll(this, 'render');

      this._super();
    },

    render: function() {

      this.elm.html(this.getTemplate(jstTemplate, {
        groups: this.options.groups,
        count: this.options.inboxCount,
        translations: {
          message: t('Someone sends me a message #unfollow'),
          reference: t('I am given a task, @mentioned, or added to a meeting, bug report, etc. #unfollow'),
          space: t('Changes in workspace membership occur (add, leave, join etc) #unfollow'),
          subscription: t('When something happens on anything I follow, or have interacted with #unfollow'),
          reminder: t('When I am being reminded about something #unfollow')
        }
      }));

    }

  });

});

